import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { GET_ONBOARDING_URL } from "../../graphql/company";
import {
  Button,
  Typography,
  Link,
  Stack as MuiStack,
  Divider,
  List,
  ListItem,
  ListItemText,
  Paper,
} from "@mui/material";
import { ListItemIcon } from "@outpave/ds";
import MapsHomeWorkOutlinedIcon from "@mui/icons-material/MapsHomeWorkOutlined";
import PatriotActNotice from "../../components/common/PatriotActNotice";
import { Center, Stack } from "components/layout/reusableLayouts";
import { useBrandingContext } from "context/BrandingContext";
import { useNavigate } from "react-router-dom";

function Start() {
  const navigate = useNavigate();

  const { data: onboarding, loading } = useQuery(GET_ONBOARDING_URL, {
    fetchPolicy: "network-only",
  });

  const openHostedOnboarding = () => {
    if (onboarding?.getOnboardingUrl) {
      window.open(onboarding?.getOnboardingUrl, "_self");
    } else {
      navigate("/onboarding/business");
    }
  };

  const { t } = useTranslation();
  const { platform } = useBrandingContext();

  const documents = (platform?.agreements ?? []).filter((doc) => doc.url);

  return (
    <Center maxWidth={600}>
      <Paper sx={{ padding: "var(--space-9)" }}>
        <Stack gap="var(--space-5)">
          <Typography variant="h4" component="h1" align="center">
            {t(`Let's get started!`)}
          </Typography>
          <Typography variant="body1">
            {t(
              "Heads Up! We'll be asking for business, leadership, ownership and banking info",
            )}{" "}
            <PatriotActNotice inline />
          </Typography>

          <Typography variant="body1">
            {t("In order to qualify for Outpave a business must ")}
          </Typography>
          <List disablePadding>
            <ListItem disableGutters>
              <ListItemIcon wrapper="brand">
                <MapsHomeWorkOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary={t("Be a US-based company")} />
            </ListItem>
          </List>
          <Typography variant="body1">
            {t(
              `Application process will take 5 - 10 min When you are ready, click Start Application to begin`,
            )}
          </Typography>

          <Button
            variant="primary-filled"
            size="large"
            onClick={openHostedOnboarding}
            loading={loading}
            fullWidth
          >
            {t("Start Application")}
          </Button>

          {documents.length > 0 && (
            <>
              <Divider />
              <MuiStack
                direction="row"
                useFlexGap
                spacing={1}
                divider={
                  <Typography
                    variant="caption"
                    component="span"
                    aria-hidden
                    sx={{ color: "text.disabled" }}
                  >
                    &middot;
                  </Typography>
                }
                sx={{
                  flexWrap: "wrap",
                  justifyContent: "center",
                }}
              >
                {documents.map((doc) => (
                  <Link
                    key={doc.key}
                    href={doc.url as string}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                    variant="caption"
                    sx={{ color: "text.secondary" }}
                  >
                    {t(doc.label, { nsSeparator: false, keySeparator: false })}
                  </Link>
                ))}
              </MuiStack>
            </>
          )}
        </Stack>
      </Paper>
    </Center>
  );
}

export default Start;
